import React from 'react';
import {computed, action, observable, observe} from 'mobx';

/* eslint-disable react/no-multi-comp */

const isServer = typeof window === 'undefined';

export function cmpt(target, name, descriptor) {
  const {initializer} = descriptor;

  if (!initializer) throw new Error('@cmpt can only be used with initializers');

  Object.assign(descriptor, {
    get: initializer,
    initializer: void 0,
  });

  return computed(target, name, descriptor) || descriptor;
}

export function observer(Component) {
  if (typeof Component !== 'function') throw new Error('Invalid use of `observer`');

  if (isServer) return Component;

  if (!Component.prototype) {
    // pure components
    return @observer class Observer extends React.Component {
      static displayName = `MobxObserverWrapper(${Component.displayName || Component.name})`;

      render() {
        return <Component {...this.props} />;
      }
    };
  }


  return class Observer extends React.Component {
    static displayName = `MobxObserver(${Component.displayName || Component.name})`;

    UNSAFE_componentWillMount() {
      const parent = this;
      const {render} = Component.prototype;
      this.Component = class extends Component {
        render() {
          console.log('render');
          if (parent.dispose) parent.dispose();
          let rendered;

          const comp = computed(() => {
            console.log('rendered', rendered);
            rendered = render.apply(this);
            console.log('rendered', rendered);
          });

          parent.dispose = observe(
            comp,
            () => {
              console.log('react');
              this.forceUpdate();
            },
            true,
          );

          comp();

          return rendered;
        }
      };
    }

    componentWillUnmount() {
      if (this.dispose) this.dispose();
    }

    render() {
      return <this.Component {...this.props} />;
    }
  };
}

export function mobxPromise(promise) {
  const obsrv = observable({
    resolved() { return this.fulfilled || this.rejected; },
    fulfilled: false,
    rejected: false,
    result: void 0,
    exception: void 0,
  });
  promise.then(
    action((result) => {
      obsrv.fulfilled = true;
      obsrv.result = result;
    }),
    action((exception) => {
      obsrv.rejected = true;
      obsrv.exception = exception;
    }),
  );
  return obsrv;
}



// WEBPACK FOOTER //
// ./utils/mobx.jsx